<ll-titulo>Ayuda</ll-titulo>
<div class="row">
    <div class="col-sm-6">
        <menu-grid-layout [menuItems]="menuItems" *ngIf="enableMenu" [maxColumns]="1"></menu-grid-layout>
    </div>
    <div class="col-sm-6">
        <ayuda-info></ayuda-info>
        <ayuda-contacto [usuarioId]="usuarioId"></ayuda-contacto>
    </div>
</div>